import {
  buildEnquiryMessage,
  buildOrderMessage,
  STORE_NAME,
  whatsappChatLink,
  whatsappLink,
  type OrderLine,
} from '@neyara/shared';
import { useConfig } from './queries';

/**
 * WhatsApp links for the configured store number.
 * Returns null while the number is loading or not configured, so callers can hide or disable ordering.
 */
export function useWhatsApp() {
  const { data: config } = useConfig();
  const number = config?.whatsappNumber;
  if (!number) return null;

  const options = { storeName: STORE_NAME, siteUrl: window.location.origin };
  return {
    order: (lines: OrderLine[]) => whatsappLink(number, buildOrderMessage(lines, options)),
    enquire: (saree: Pick<OrderLine, 'name' | 'slug'>) => whatsappLink(number, buildEnquiryMessage(saree, options)),
    chat: () => whatsappChatLink(number),
  };
}
